interface StepperProps {
  steps: readonly string[];
  current: number; // 1-based step number; > steps.length means all done
  /** When set, marks that step (1-based) as having errored. Visually overrides 'active'. */
  errorStep?: number;
}

export function Stepper({ steps, current, errorStep }: StepperProps) {
  return (
    <ol className="stepper">
      {steps.map((label, i) => {
        const n = i + 1;
        const isError = errorStep === n;
        const state = isError
          ? 'error'
          : n < current
            ? 'done'
            : n === current
              ? 'active'
              : '';
        const numStr = n < 10 ? `0${n}` : String(n);
        return (
          <li key={label} className={`step ${state}`}>
            <span className="step-num">{numStr}</span>
            <span className="step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
